import React from 'react';
import Button from "components/CustomButtons/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import { Calendar } from 'react-date-range';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import CATEGORY_PARAMS from '../../../utils/category-config.js';
import InformationTooltip from "../../../app-components/information-tooltip";

import {
  URL_VALIDATION,
  FACEBOOK_VALIDATION,
  TWITTER_VALIDATION,
  INSTA_VALIDATION
} from "../../../app-constants/common.js";

const getKeyCondition = (id, val) => {
  if (id == 'fbUrl') {
    return !FACEBOOK_VALIDATION.test(val)
  }
  if (id == 'twitterUrl') {
    return !TWITTER_VALIDATION.test(val)
  }
  if (id == 'instaUrl') {
    return !INSTA_VALIDATION.test(val)
  }
  if (id == 'heroImage') {
    return !URL_VALIDATION.test(val)
  }
  return false
}
const validation = (error = {}, id, val) => {
  if (id == 'displayName') {
    (val == '') ? error = { ...error, [id]: true } : error = { ...error, [id]: false }
    return { error, val }
  }
  if (getKeyCondition(id, val)) {
    if (val == "") {
      error = { ...error, [id]: false };
      val = null;
    }
    else {
      error = { ...error, [id]: true };
    }
  }
  else {
    error = { ...error, [id]: false };
  }
  return { error, val }
}

const styles = {
  fieldLabel: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#2b2d42',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  fieldInput: {
    width: '100%',
    padding: '9px 12px',
    fontSize: '13px',
    fontFamily: "'Source Sans Pro', sans-serif",
    border: '1px solid #ced3dc',
    borderRadius: '4px',
    outline: 'none',
    color: '#2b2d42',
    transition: 'border-color 0.2s ease',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  fieldHelper: {
    fontSize: '11px',
    color: '#8d99ae',
    marginTop: '4px',
    lineHeight: '1.4',
  },
  fieldError: {
    fontSize: '11px',
    color: '#e63946',
    marginTop: '4px',
  },
  fieldGroup: {
    marginBottom: '16px',
  },
  sectionHeader: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#5d737e',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    marginBottom: '12px',
    paddingBottom: '6px',
    borderBottom: '2px solid #e8ecf1',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  requiredStar: {
    color: '#e63946',
    marginLeft: '1px',
    fontSize: '13px',
  },
  uploadBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: '#2b2d42',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'background-color 0.2s',
  },
};

class LpDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      displayName: null,
      description: null,
      searchName: null,
      dob: null,
      fbUrl: null,
      twitterUrl: null,
      instaUrl: null,
      id: null,
      formatDate: null,
      heroImage: null,
      active: 1,
      error: {
        displayName: false,
        fbUrl: false,
        twitterUrl: false,
        instaUrl: false,
        heroImage: false
      }
    }
  }
  handleChange = event => {
    const { id, value } = event.target;
    const { val, error } = validation(this.state.error, id, value)
    this.setState({ ...this.state, [id]: val, error })
  }
  handleActiveChange = event => {
    const { name, value } = event.target;
    this.setState({ ...this.state, [name]: value })
  }
  componentWillReceiveProps(props) {
    if (props.cropedUrl) {
      this.setState({ ...this.state, heroImage: props.cropedUrl })
      return
    }
    const { lpData = {} } = props;
    const date = CATEGORY_PARAMS[props.subCategoryName] ? CATEGORY_PARAMS[props.subCategoryName]['field'] : 'date';
    const { id, displayName, description, searchName, fbUrl, twitterUrl, instaUrl, heroImage, active } = lpData;
    this.setState({ ...this.state, id, displayName, heroImage, description, searchName, ['dob']: (lpData[date] ? moment(lpData[date]) : null), fbUrl, twitterUrl, instaUrl, formatDate: `${lpData[date] ? moment(lpData[date]).format("YYYY-MM-DD") : ''}`, active })
  }
  onSubmit = () => {
    const { lpModalId, setLpEntry, categoryName, subCategoryName } = this.props;
    const date = CATEGORY_PARAMS[subCategoryName] ? CATEGORY_PARAMS[subCategoryName]['field'] : 'date';
    const { displayName, description, heroImage, active, dob, fbUrl, twitterUrl, instaUrl, searchName } = this.state;
    setLpEntry({ searchName, displayName, description, [date]: dob, fbUrl, twitterUrl, heroImage, instaUrl, active }, lpModalId)
  }
  handleSelect = (date) => {
    this.setState({ ...this.state, ['dob']: moment(date), ['formatDate']: `${moment(date).format("YYYY-MM-DD")}` }, () => {
      this.handleClose()
    })
  }
  openPiscoForAvator = () => {
    this.props.openPisco();
    setTimeout(() => {
      this.props.COPYCARDID();
      this.props.removeLpModal();
    }, 800)
  }
  closeLpModal = () => {
    this.setState({ id: null, displayName: null, heroImage: null, description: null, searchName: null, dob: null, fbUrl: null, twitterUrl: null, instaUrl: null, formatDate: null, active: 1 })
    this.props.reSetCropedUrl();
    this.props.removeLpModal();
  }
  isValid = () => {
    const { displayName, heroImage, fbUrl, twitterUrl, instaUrl } = this.state.error;
    if (!displayName && !heroImage && !fbUrl && !twitterUrl && !instaUrl) {
      return true
    }
    else {
      return false
    }
  }
  handleOpen = () => {
    this.setState({ ...this.state, open: true })
  }
  handleClose = () => {
    this.setState({ ...this.state, open: false })
  }

  getBorderColor = (fieldName, value) => {
    if (this.state.error[fieldName]) return '#e63946';
    if (value) return '#24c32a';
    return '#ced3dc';
  }

  render() {
    const { lpModalId, categoryName, subCategoryId, subCategoryName, openPisco, categories, lpData = {} } = this.props;
    const { displayName, id, description, heroImage, searchName, dob, fbUrl, twitterUrl, instaUrl } = this.state;

    return (
      <div>
        <Dialog
          open={Boolean(lpModalId)}
          onClose={this.closeLpModal}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          {/* ── Header ── */}
          <DialogTitle id="form-dialog-title" style={{ paddingBottom: '4px', borderBottom: '1px solid #e8ecf1' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '36px', height: '36px', borderRadius: '8px', backgroundColor: '#f0f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="material-icons" style={{ fontSize: '20px', color: '#2b2d42' }}>edit</i>
              </div>
              <div>
                <div style={{ fontSize: '17px', fontWeight: 600, color: '#2b2d42', lineHeight: '1.3' }}>
                  Edit Profile{displayName ? `: ${displayName}` : ''}
                </div>
                <div style={{ fontSize: '12px', color: '#8d99ae', fontWeight: 400, lineHeight: '1.4' }}>
                  Update profile details. Last 100 articles will be auto re-tagged on save.
                </div>
              </div>
            </div>
          </DialogTitle>

          <DialogContent style={{ padding: '20px 24px 8px' }}>
            {/* ── Section: Basic Information ── */}
            <div style={{ marginBottom: '20px' }}>
              <div style={styles.sectionHeader}>
                <i className="material-icons" style={{ fontSize: '15px' }}>badge</i>
                Basic Information
              </div>

              {/* Row: Status + Display Name */}
              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                {/* Status */}
                <div style={{ width: '160px', flexShrink: 0 }}>
                  <div style={styles.fieldLabel}>
                    Status
                    <InformationTooltip text="Active profiles are visible on the website. Inactive profiles are hidden." size={13} />
                  </div>
                  <Select
                    value={this.state.active}
                    onChange={this.handleActiveChange}
                    inputProps={{ name: 'active', id: 'active' }}
                    style={{ fontSize: '13px', width: '100%', border: '1px solid #ced3dc', borderRadius: '4px', padding: '3px 8px', height: '36px', backgroundColor: '#fff' }}
                    disableUnderline
                  >
                    <MenuItem value={1}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#24c32a', display: 'inline-block' }}></span>
                        Active
                      </span>
                    </MenuItem>
                    <MenuItem value={0}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#8d8d8d', display: 'inline-block' }}></span>
                        Inactive
                      </span>
                    </MenuItem>
                  </Select>
                </div>

                {/* Display Name */}
                <div style={{ flex: 1 }}>
                  <div style={styles.fieldLabel}>
                    Display Name <span style={styles.requiredStar}>*</span>
                    <InformationTooltip text="The name shown on the profile page." size={13} />
                  </div>
                  <input
                    type="text"
                    id="displayName"
                    value={displayName || ''}
                    onChange={this.handleChange}
                    placeholder="e.g., Taylor Swift"
                    style={{ ...styles.fieldInput, borderColor: this.getBorderColor('displayName', displayName), height: '36px' }}
                    onFocus={(e) => { e.target.style.borderColor = '#2b2d42'; e.target.style.boxShadow = '0 0 0 2px rgba(43,45,66,0.08)'; }}
                    onBlur={(e) => { e.target.style.borderColor = this.getBorderColor('displayName', this.state.displayName); e.target.style.boxShadow = 'none'; }}
                  />
                  {this.state.error.displayName && <div style={styles.fieldError}>Display name is required</div>}
                </div>
              </div>

              {/* Search Keywords */}
              <div style={styles.fieldGroup}>
                <div style={styles.fieldLabel}>
                  Search Keywords
                  <InformationTooltip text="Each keyword is matched against the article's Title, SEO Title, OG Title and Summary. Words in the phrase can appear up to 2 positions apart. Separate multiple keywords with commas." size={13} />
                </div>
                <input
                  type="text"
                  id="searchName"
                  value={searchName || ''}
                  onChange={this.handleChange}
                  placeholder="e.g., taylor swift, t swift (comma-separated)"
                  style={{ ...styles.fieldInput, borderColor: this.getBorderColor('searchName', searchName), height: '36px' }}
                  onFocus={(e) => { e.target.style.borderColor = '#2b2d42'; e.target.style.boxShadow = '0 0 0 2px rgba(43,45,66,0.08)'; }}
                  onBlur={(e) => { e.target.style.borderColor = this.getBorderColor('searchName', this.state.searchName); e.target.style.boxShadow = 'none'; }}
                />
                <div style={styles.fieldHelper}>Comma-separated. Matched against article Title, SEO Title, OG Title &amp; Summary.</div>
              </div>
            </div>

            {/* ── Section: Profile Details ── */}
            <div style={{ marginBottom: '8px' }}>
              <div style={styles.sectionHeader}>
                <i className="material-icons" style={{ fontSize: '15px' }}>article</i>
                Profile Details
              </div>

              {/* Description */}
              <div style={styles.fieldGroup}>
                <div style={styles.fieldLabel}>
                  Bio / Description
                  <InformationTooltip text="A short bio or description shown on the profile page." size={13} />
                </div>
                <textarea
                  id="description"
                  value={description || ''}
                  onChange={this.handleChange}
                  placeholder="Write a short bio..."
                  rows={3}
                  style={{ ...styles.fieldInput, resize: 'vertical', minHeight: '55px', lineHeight: '1.5' }}
                  onFocus={(e) => { e.target.style.borderColor = '#2b2d42'; e.target.style.boxShadow = '0 0 0 2px rgba(43,45,66,0.08)'; }}
                  onBlur={(e) => { e.target.style.borderColor = '#ced3dc'; e.target.style.boxShadow = 'none'; }}
                />
                <div style={styles.fieldHelper}>Shown on the public profile page. Optional.</div>
              </div>

              {/* Profile Picture */}
              <div style={styles.fieldGroup}>
                <div style={styles.fieldLabel}>
                  Profile Picture
                  <InformationTooltip text="Paste an image URL or click the upload button to browse the media library." size={13} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="text"
                    id="heroImage"
                    value={heroImage || ''}
                    onChange={this.handleChange}
                    placeholder="Paste image URL or use upload button →"
                    style={{ ...styles.fieldInput, flex: 1, borderColor: this.getBorderColor('heroImage', heroImage), height: '36px' }}
                    onFocus={(e) => { e.target.style.borderColor = '#2b2d42'; e.target.style.boxShadow = '0 0 0 2px rgba(43,45,66,0.08)'; }}
                    onBlur={(e) => { e.target.style.borderColor = this.getBorderColor('heroImage', this.state.heroImage); e.target.style.boxShadow = 'none'; }}
                  />
                  <div
                    onClick={this.openPiscoForAvator}
                    style={styles.uploadBtn}
                    title="Upload from media library"
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#3d3f5c'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#2b2d42'; }}
                  >
                    <i className="material-icons" style={{ fontSize: '18px', color: '#fff' }}>add_photo_alternate</i>
                  </div>
                </div>
                {this.state.error.heroImage
                  ? <div style={styles.fieldError}>Please enter a valid image URL</div>
                  : <div style={styles.fieldHelper}>Upload from media library or paste a direct URL.</div>
                }
              </div>
            </div>
          </DialogContent>

          {/* ── Footer ── */}
          <DialogActions style={{ padding: '12px 24px 16px', borderTop: '1px solid #e8ecf1', justifyContent: 'flex-end', gap: '8px' }}>
            <Button onClick={this.closeLpModal} style={{ color: '#5d737e', fontSize: '12px', fontWeight: 500, border: '1px solid #ced3dc', borderRadius: '4px', padding: '6px 16px', minWidth: '80px' }}>
              Cancel
            </Button>
            <Button disabled={!this.isValid()} onClick={this.onSubmit} color="primary" style={{ fontSize: '12px', fontWeight: 600, borderRadius: '4px', padding: '6px 20px', minWidth: '120px' }}>
              <i className="material-icons" style={{ fontSize: '15px', marginRight: '4px' }}>save</i>
              Update Profile
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default LpDialog
